module.exports = __webpack_public_path__ + "static/media/close-external-leyer.3061a1c7.svg";